import { AxiosResponse } from "axios";
import { api } from "../api";
import {
  TiendaColegio,
  CreateTiendaColegioDto,
  UpdateTiendaColegioDto,
} from "./tienda-colegio.types";

export const getTiendaColegios = async (): Promise<TiendaColegio[]> => {
  try {
    const response: AxiosResponse<TiendaColegio[]> = await api.get(
      "/tienda/admin/colegios"
    );
    return response.status === 200 ? response.data : [];
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const getTiendaColegio = async (
  id: number
): Promise<TiendaColegio | null> => {
  try {
    const response: AxiosResponse<TiendaColegio> = await api.get(
      `/tienda/admin/colegios/${id}`
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const createTiendaColegio = async (
  dto: CreateTiendaColegioDto
): Promise<TiendaColegio | null> => {
  try {
    const response: AxiosResponse<TiendaColegio> = await api.post(
      "/tienda/admin/colegios",
      dto
    );
    return response.status === 201 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const updateTiendaColegio = async (
  id: number,
  dto: UpdateTiendaColegioDto
): Promise<TiendaColegio | null> => {
  try {
    const response: AxiosResponse<TiendaColegio> = await api.patch(
      `/tienda/admin/colegios/${id}`,
      dto
    );
    return response.status === 200 ? response.data : null;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};

export const deleteTiendaColegio = async (id: number): Promise<boolean> => {
  try {
    const response = await api.delete(`/tienda/admin/colegios/${id}`);
    return response.status === 200;
  } catch (error: any) {
    console.error(error);
    throw error;
  }
};
